// gift-wrapping.js
class GiftWrapping extends HTMLElement {
    connectedCallback() {

        const recipientCheckbox = this.querySelector("#gift-card-recipient");
        const recipientFields = this.querySelector("#gift-recipient-fields");
        const recipientEmail = this.querySelector("#gift-recipient-email");
        const addToCartButton =
            this.closest("form")?.querySelector('[name="add"]') ||
            document.querySelector("#add");
        if (!addToCartButton) return;

        // Bind events
        if (recipientCheckbox) {
            recipientCheckbox.addEventListener("change", () => {
                const isChecked = recipientCheckbox.checked;

                if (isChecked) {
                    recipientFields.style.display = "block";
                    if (!recipientEmail.value.length) {
                        addToCartButton.disabled = true;
                    }
                } else {
                    recipientFields.style.display = "none";
                    addToCartButton.disabled = false;
                    recipientEmail.value = "";
                    this.querySelector("#gift-recipient-name").value = "";
                    this.querySelector("#gift-recipient-message").value = "";
                }
            });
        }

        if (recipientEmail) {
            recipientEmail.addEventListener("input", () => {
                const isValid =
                    recipientEmail.value.length > 0 && recipientEmail.value.includes("@");

                if (!isValid) {
                    addToCartButton.disabled = true;
                } else {
                    addToCartButton.disabled = false;
                }
            });
        }
    }
}

if (!window.customElements.get('gift-wrapping')) {
    customElements.define("gift-wrapping", GiftWrapping);
}